import { useEffect, useRef, useState } from "react"
import "../../styles/art/nightsky.css"

function NightSky() {

    const [shootingStarDivs, setShootingStarDivs] = useState([])
    const [shootingStarNum, setShootingStarNum] = useState(0)

    const shootingStarRef = useRef(null)

    useEffect(() => {
        const interval = setInterval(() => {
            let newDiv = <div ref={shootingStarRef} key={shootingStarNum} className="shooting-star"><span></span></div>
            setShootingStarDivs(prev => [...prev, newDiv])
            setShootingStarNum(shootingStarNum + 1)
            if (shootingStarRef.current != null) {
                if (Math.floor(Math.random()*2) === 0) {
                    shootingStarRef.current.style.left = `${Math.floor(Math.random()*80)}%`
                    shootingStarRef.current.style.rotate = `${Math.floor(Math.random()*50) + 10}deg`
                }
                else {
                    shootingStarRef.current.style.right = `${Math.floor(Math.random()*80) * -1}%`
                    shootingStarRef.current.style.rotate = `${Math.floor(-Math.random()*50) - 190}deg`
                }
            }
            if (shootingStarDivs.length >= 10) {
                setShootingStarDivs((prev) => prev.slice(1))
            }
            
        }, Math.floor(Math.random()*2000));
        return () => clearInterval(interval)
    }, [shootingStarDivs, shootingStarNum])
    return (
        <div className="nightsky-container">
            {shootingStarDivs}
        </div>
    )
}

export { NightSky }